import { useTranslations } from 'next-intl';
import { useState } from 'react';

import ChevronIcon from '@/fo/icons/base/icons/chevron24.svg';
import IconSearch from '@/fo/icons/base/icons/search.svg';
import { UiKitCheckboxBase } from '@/fo/ui/kit/checkbox/base';
import { UiKitCollapseBase } from '@/fo/ui/kit/collapse/base';
import { UiKitInputSearch } from '@/fo/ui/kit/input/search';
import { UiKitLabelBase } from '@/fo/ui/kit/label/base';

import { FilterOption } from '../../../types';
import { FilterComponentProps } from '../types';

import { styles } from './CheckboxFilter.styles';

export function CheckboxFilter({
  options,
  selected,
  onChange,
  label
}: FilterComponentProps & { label?: string }) {
  const t = useTranslations();
  const [collapse, setCollapse] = useState(true);
  const slots = styles({ collapse });
  const [searchQuery, setSearchQuery] = useState('');

  const filteredOptions = searchQuery
    ? (options as FilterOption[]).filter((option) =>
        option.label.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : (options as FilterOption[]);

  const highlightText = (text: string) => {
    if (!searchQuery) return text;

    const regex = new RegExp(
      `(${searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
      'gi'
    );
    const parts = text.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? <b key={index}>{part}</b> : part
    );
  };

  const errorFound = filteredOptions?.length === 0 && searchQuery?.length > 0;

  return (
    <div className={slots.base()}>
      <div
        className={slots.header()}
        onClick={() => setCollapse((s) => !s)}
      >
        <div className={slots.label()}>
          {label}
          {selected?.length && (
            <UiKitLabelBase color="orange">{selected?.length}</UiKitLabelBase>
          )}
        </div>
        <ChevronIcon className={slots.chevron()} />
      </div>
      <UiKitCollapseBase
        collapse={collapse}
        className={slots.collapse()}
      >
        <div className={slots.options()}>
          <div className={slots.searchContainer()}>
            <UiKitInputSearch
              label={t('find')}
              placeholder={t('find')}
              startAdornment={<IconSearch />}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              helperText={
                errorFound ? t('productCatalog.inputSearchNotFound') : undefined
              }
              error={errorFound}
            />
          </div>
          {filteredOptions.map((option) => {
            const isSelected =
              Array.isArray(selected) &&
              selected.some((value) => value === option.value);

            return (
              <UiKitCheckboxBase
                key={option.value}
                label={highlightText(option.label)}
                checked={isSelected}
                onChange={(checked) => onChange(option.value, checked)}
                classNameInner={slots.checkbox()}
              />
            );
          })}
        </div>
      </UiKitCollapseBase>
    </div>
  );
}
